import { useNavigate } from 'react-router'
import { useApp } from '../state/AppProvider'

export function Toast() {
  const { toast, dismissToast } = useApp()
  const navigate = useNavigate()
  if (!toast) return null

  return (
    <div className="toast" role="status" aria-live="polite">
      <span className="toast__text">{toast.message}</span>
      {toast.actionTo && (
        <button
          type="button"
          className="toast__action"
          onClick={() => {
            dismissToast()
            void navigate(toast.actionTo!)
          }}
        >
          {toast.actionLabel ?? '보기 →'}
        </button>
      )}
    </div>
  )
}
